import { readonly, ref } from 'vue';

const title = ref('Dometry');

/**
 * The current page's title, shown in the phone top bar and the browser tab.
 * Routes provide a default (meta.title); pages with a better name (a project)
 * override it.
 */
export function usePageTitle() {
  /** Undefined means "no specific page title". */
  function set(value: string | undefined): void {
    title.value = value ?? 'Dometry';
    document.title = value === undefined ? 'Dometry' : `${value} · Dometry`;
  }
  return { title: readonly(title), set };
}
